import { MoreVert } from '@mui/icons-material';
import { IconButton, MenuItem } from '@mui/material';
import { useMenu } from '@prismamedia/one-components';
import { FC } from 'react';
import { BlockItemFormat } from '../..';
import {
  DELETE_LABEL,
  LEADER_SUBJECT_LABEL,
  SEE_ARTICLE_LABEL,
} from './constants';

enum BlockTypeLabel {
  AUTO_PROMO = "l'auto-promo",
  ARTICLE = "l'article",
  DIAPO = 'le diapo',
  FREE_CONTENT = 'le contenu libre',
  RECETTE = 'la recette',
}

const getBlockTypeLabel = (blockType = '') => {
  const lowercasedBlockType = blockType.toLowerCase();

  switch (lowercasedBlockType) {
    case 'autopromo': {
      return BlockTypeLabel.AUTO_PROMO;
    }
    case 'article': {
      return BlockTypeLabel.ARTICLE;
    }
    case 'diapo': {
      return BlockTypeLabel.DIAPO;
    }
    case 'libre': {
      return BlockTypeLabel.FREE_CONTENT;
    }
    case 'recette': {
      return BlockTypeLabel.RECETTE;
    }
    default: {
      return '';
    }
  }
};

interface MenuProps {
  articlePublicURL: string;
  blockItemFormat: BlockItemFormat;
  blockType?: string | null;
  onSeeArticle?: () => void;
  onDeleteBlock?: () => void;
  onSetLeadIn?: () => void;
}

export const Menu: FC<MenuProps> = ({
  blockItemFormat,
  blockType = '',
  articlePublicURL,
  onDeleteBlock,
  onSeeArticle,
  onSetLeadIn,
}) => {
  const { openMenu, closeMenu } = useMenu();

  const handleSeeArticle = () => {
    if (articlePublicURL) {
      window.open(articlePublicURL);
      onSeeArticle?.();
    }
  };

  const items = [
    ...(articlePublicURL.length
      ? [
          {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            value: `${SEE_ARTICLE_LABEL} ${getBlockTypeLabel(blockType!)}`,
            onClick: handleSeeArticle,
          },
        ]
      : []),
    ...(blockItemFormat === BlockItemFormat.AUTO_PROMO ||
    blockItemFormat === BlockItemFormat.EXPANDED
      ? [
          {
            value: LEADER_SUBJECT_LABEL,
            onClick: onSetLeadIn,
          },
          {
            value: DELETE_LABEL,
            onClick: onDeleteBlock,
          },
        ]
      : []),
  ];

  return (
    <IconButton
      arial-label="more"
      data-testid="menuBtn"
      onClick={(e) =>
        openMenu(
          e.currentTarget,
          <div>
            {items.map((item, i) => (
              <MenuItem
                key={i}
                onClick={() => {
                  item.onClick?.();
                  closeMenu();
                }}
              >
                {item.value}
              </MenuItem>
            ))}
          </div>,
        )
      }
    >
      <MoreVert />
    </IconButton>
  );
};
